import { render, staticRenderFns } from "./BillboardBlock.vue?vue&type=template&id=7ea41f4e&"
import script from "./BillboardBlock.vue?vue&type=script&lang=js&"
export * from "./BillboardBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports